import { createAction } from "redux-actions";
import isEmail from "validator/lib/isEmail";
import _size from "lodash/size";
//
import Api from "../../services/Api";
import { createPromiseActionTypes } from "../../utils/redux";
import { getUserAction } from "../auth";
import { ajaxPendingAction, ajaxErrorAction, ajaxSuccessAction } from "../ajax";
import { goToScreen } from "../modal";

// Actions Types
export const BOOKING_TIME_SET = "booking/BOOKING_TIME_SET";
export const BOOKING_DURATION_SET = "booking/BOOKING_DURATION_SET";
export const BOOKING_DURATION_CHANGE = "booking/BOOKING_DURATION_CHANGE";
export const BOOKING_INPUT_SET = "booking/BOOKING_INPUT_SET";
export const BOOKING_SERVICE_SET = "booking/BOOKING_SERVICE_SET";
export const BOOKING_ERRORS = "booking/BOOKING_ERRORS";
export const BOOKING_OUTCALL_SET = "booking/BOOKING_OUTCALL_SET";
export const BOOKING_OTPTYPE_SET = "booking/BOOKING_OTPTYPE_SET";
//
export const BOOKING_GENDER_SET = "booking/BOOKING_GENDER_SET";
export const BOOKING_CREATE = createPromiseActionTypes(
  "booking/BOOKING_CREATE"
);
export const BOOKING_PHONE_UPDATE = createPromiseActionTypes(
  "booking/BOOKING_PHONE_UPDATE"
);
export const BOOKING_VERIFY = createPromiseActionTypes(
  "booking/BOOKING_VERIFY"
);
export const BOOKING_CALLME = createPromiseActionTypes(
  "booking/BOOKING_CALLME"
);

export const EMAIL_OTP_SEND = createPromiseActionTypes(
  "booking/EMAIL_OTP_SEND"
);

// Actions
export const setTimeAction = createAction(BOOKING_TIME_SET);
export const setDurationAction = createAction(BOOKING_DURATION_SET);
export const setGenderAction = createAction(BOOKING_GENDER_SET);
const _setOutcallAction = createAction(BOOKING_OUTCALL_SET);

export const setOutcallAction = (outcall) => async (dispatch, getState) => {
  dispatch(_setOutcallAction(outcall));
  dispatch(goToScreen("time"));
};

export const setBookingInputAction = createAction(
  BOOKING_INPUT_SET,
  (name, value) => ({ name, value })
);
export const setBookingServiceAction = createAction(BOOKING_SERVICE_SET);

const createBookingPendingAction = createAction(BOOKING_CREATE.PENDING);
const createBookingFulfilledAction = createAction(BOOKING_CREATE.FULFILLED);

const updateBookingPhoneFulfilledAction = createAction(
  BOOKING_PHONE_UPDATE.FULFILLED
);

const bookingErrorsAction = createAction(BOOKING_ERRORS);
const _setOtpTypeAction = createAction(BOOKING_OTPTYPE_SET);

export function setOtpTypeAction(otpType) {
  return async (dispatch, getState) => {
    const { booking } = getState();

    dispatch(_setOtpTypeAction(otpType));

    if (otpType === "sms") {
      dispatch(goToScreen("verify-phone"));
      return;
    }

    if (booking.otpType === "call" && otpType === "email") {
      dispatch(goToScreen("verify-email"));
      return;
    }

    // if (otpType === "email" && /* (auth.trusted &&) */ auth.verified) {
    //   dispatch(verifyBookingManuallyAction(booking.id));
    //   return;
    // }
  };
}

export function verifyBookingManuallyAction(bookingId) {
  return async (dispatch) => {
    const res = await Api.verifyBookingManually(bookingId);

    if (res.redirect) {
      window.location.href = res.redirect;
    } else {
      dispatch(goToScreen("thankyou"));
    }
  };
}

const sendEmailOtpPendingAction = createAction(EMAIL_OTP_SEND.PENDING);
const sendEmailOtpFulfilledAction = createAction(EMAIL_OTP_SEND.FULFILLED);

export function sendEmailOtpAction() {
  return async (dispatch, getState) => {
    const { booking } = getState();

    dispatch(sendEmailOtpPendingAction());

    try {
      await Api.sendEmailOtp(booking.id);
      dispatch(sendEmailOtpFulfilledAction());
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  };
}

export function sendBookingAction() {
  return async (dispatch, getState) => {
    const state = getState();
    const { booking, countries, locations, auth } = state;
    const errors = _validateBooking(booking, locations.active);

    if (_size(errors)) {
      dispatch(bookingErrorsAction(errors));
    } else {
      dispatch(bookingErrorsAction([]));

      const { models, intl } = state;

      dispatch(createBookingPendingAction());

      const phoneCountry = countries.entities[countries.active];

      try {
        const res = await Api.createBooking(
          booking,
          phoneCountry.id,
          intl.cityId,
          models.active,
          locations.active,
          cookie("utm_source"),
          cookie("tap_click"),
          auth.ga
        );

        if (res.thankyou) {
          dispatch(ajaxSuccessAction());
          dispatch(goToScreen("thankyou"));
        } else {
          dispatch(createBookingFulfilledAction(res));

          if (res.password) {
            dispatch(goToScreen("verify-password"));
          } else if (res.verified) {
            dispatch(verifyBookingManuallyAction(res.id));
          } else {
            dispatch(setOtpTypeAction("email"));
            dispatch(sendEmailOtpAction());
          }
        }
      } catch (err) {
        if (err.data) {
          dispatch(ajaxErrorAction(err.data));
        } else {
          throw err;
        }
      }
    }
  };
}

function _validateBooking(booking, locationId) {
  const errors = {};

  if (!booking.fullname) {
    errors["fullname"] = true;
  }

  if (!booking.email) {
    errors["email"] = true;
  } else if (!isEmail(booking.email) || /[À-ÿ]/.test(booking.email)) {
    errors["email"] = true;
  }

  if (!booking.phone) {
    errors["phone"] = true;
  }

  if (booking.contact_provider !== "phone" && !booking.contact_provider_id) {
    errors["contact_provider_id"] = true;
  }

  if (booking.outcall) {
    if (!locationId) {
      errors["location"] = true;
    }

    if (!booking.roomNumber) {
      errors["roomNumber"] = true;
    }
  }

  return errors;
}

export const updateBookingPhoneAction =
  (phone, country) => async (dispatch, getState) => {
    const { booking } = getState();

    dispatch(ajaxPendingAction());

    try {
      const payload = await Api.sendSmsOtp(booking, phone, country);

      if (payload.thankyou) {
        dispatch(ajaxSuccessAction());
        dispatch(goToScreen("thankyou"));
      } else {
        dispatch(updateBookingPhoneFulfilledAction(payload));
      }
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  };

const _changeDurationAction = createAction(BOOKING_DURATION_CHANGE);

export function changeDurationAction(payload) {
  return (dispatch) => {
    dispatch(ajaxPendingAction());

    setTimeout(() => {
      dispatch(ajaxSuccessAction());
      dispatch(_changeDurationAction(payload));
    }, 500);
  };
}

const verifyBookingPendingAction = createAction(BOOKING_VERIFY.PENDING);
const verifyBookingFulfilledAction = createAction(BOOKING_VERIFY.FULFILLED);

export function verifyPasswordAction({ email, password }) {
  return async (dispatch, getState) => {
    dispatch(ajaxPendingAction());

    try {
      await Api.login(email, password);

      dispatch(getUserAction());

      const { auth, booking } = getState();

      if (auth.verified) {
        dispatch(verifyBookingManuallyAction(booking.id));
      } else {
        dispatch(setOtpTypeAction("email"));
        dispatch(sendEmailOtpAction());
      }
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  };
}

export function verifyBookingAction(otp) {
  return async (dispatch, getState) => {
    const { booking } = getState();

    dispatch(verifyBookingPendingAction());

    try {
      const res = await Api.verifyBooking(booking.id, otp);

      dispatch(verifyBookingFulfilledAction());

      if (booking.otpType === "call") {
        dispatch(setOtpTypeAction("email"));
      } else if (res.redirect) {
        window.location.href = res.redirect;
      } else {
        dispatch(goToScreen("thankyou"));
      }
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  };
}

const callMePendingAction = createAction(BOOKING_CALLME.PENDING);
const callMeFulfilledAction = createAction(BOOKING_CALLME.FULFILLED);

export function callMeAction() {
  return async (dispatch, getState) => {
    const { booking } = getState();

    dispatch(callMePendingAction());

    try {
      await Api.sendCallOtp(booking.id);
      dispatch(callMeFulfilledAction());
    } catch (err) {
      if (err.data) {
        dispatch(ajaxErrorAction(err.data));
      } else {
        throw err;
      }
    }
  };
}
